<template>
  <LMap style="height: 500px" :zoom="zoom" :center="center">
    <LTileLayer :url="url"></LTileLayer>
    <LMarker
      v-for="(marker, index) in markers"
      :key="index"
      :lat-lng="marker.center"
      :icon="marker.icon"
    >
      <LPopup :content="marker.description"></LPopup>
    </LMarker>
  </LMap>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const Icon_aurore = L.icon({
  iconUrl: require("../assets/aurore.jpg"),
  iconSize: [50, 50],
  iconAnchor: [22, 94],
  popupAnchor: [-3, -76]
});

const Icon_vif = L.icon({
  iconUrl: require("../assets/vif.jpg"),
  iconSize: [50, 50],
  iconAnchor: [22, 94],
  popupAnchor: [-3, -76]
});

export default {
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      zoom: 11,
      center: [45.173234, 5.758876],
      markers: [
        {
          description:
            "Cabinet de l'Aurore <br/> 9 place Frida Kahlo <br/> Du lundi au vendredi de 9h à 19h",
          center: [45.173234, 5.758876],
          icon: Icon_aurore
        },
{
          description:
            "Cabinet de Vif <br/> 12 rue du stade <br/> Les lundi et vendredi",
          center: [45.057511, 5.679182],
          icon: Icon_vif
        }
      ]
    };
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  }
};
</script>
